import carDefender from "@/assets/car-defender.webp";
import carFerrari from "@/assets/car-ferrari.webp";
import carBentley from "@/assets/car-bentley.webp";
import carPorsche from "@/assets/car-porsche.webp";
import carLamborghiniUrus from "@/assets/car-lamborghini-urus.webp";
import carMercedesG63 from "@/assets/car-mercedes-g63.webp";
import carRangeRoverSport from "@/assets/car-range-rover-sport.webp";
import carLamborghiniHuracan from "@/assets/car-lamborghini-huracan.webp";
import carAudiRsq8 from "@/assets/car-audi-rsq8.webp";
import carRangeRover from "@/assets/car-range-rover.webp";
import { ibizaCarGalleries } from "@/data/ibiza-car-galleries";

export interface Car {
  slug: string;
  name: string;
  image: string | null;
  gallery?: string[];
  price: string;
  specs: { label: string; value: string }[];
  description: string;
}

export const cars: Car[] = [
  {
    slug: "lamborghini-revuelto",
    name: "Lamborghini Revuelto",
    image: null,
    gallery: ibizaCarGalleries["lamborghini-revuelto"],
    price: "From €2.000/day",
    specs: [
      { label: "Passengers", value: "2" },
      { label: "Engine", value: "6.5L V12 Hybrid" },
      { label: "Power", value: "1030 HP" },
      { label: "0–100 km/h", value: "2.5 sec" },
      { label: "Top Speed", value: "350 km/h" },
    ],
    description:
      "The most powerful Lamborghini ever made. The Revuelto combines a naturally aspirated V12 with three electric motors for an unprecedented 1030 HP hybrid hypercar experience.",
  },
  {
    slug: "ferrari-f8-spyder",
    name: "Ferrari 296 GTS",
    image: carFerrari,
    gallery: ibizaCarGalleries["ferrari-f8-spyder"],
    price: "From €1.500/day",
    specs: [
      { label: "Passengers", value: "2" },
      { label: "Engine", value: "3.0L V6 Hybrid" },
      { label: "Power", value: "820 HP" },
      { label: "0–100 km/h", value: "2.9 sec" },
      { label: "Top Speed", value: "330 km/h" },
    ],
    description:
      "An open-top masterpiece delivering breathtaking performance and unmistakable presence. The 296 GTS transforms every coastal road into an unforgettable drive.",
  },
  {
    slug: "ferrari-portofino-m",
    name: "Ferrari Portofino M",
    image: null,
    gallery: ibizaCarGalleries["ferrari-portofino-m"],
    price: "From €1.100/day",
    specs: [
      { label: "Passengers", value: "2" },
      { label: "Engine", value: "3.9L V8 Biturbo" },
      { label: "Power", value: "620 HP" },
      { label: "0–100 km/h", value: "3.5 sec" },
      { label: "Top Speed", value: "320 km/h" },
    ],
    description:
      "The Ferrari Portofino M is the evolution of the iconic GT spider, offering an exhilarating open-air experience with the perfect blend of elegance and performance.",
  },
  {
    slug: "lamborghini-huracan-evo-spyder",
    name: "Lamborghini Huracán EVO Spyder",
    image: carLamborghiniHuracan,
    gallery: ibizaCarGalleries["lamborghini-huracan-evo-spyder"],
    price: "From €1.100/day",
    specs: [
      { label: "Passengers", value: "2" },
      { label: "Engine", value: "5.2L V10" },
      { label: "Power", value: "640 HP" },
      { label: "0–100 km/h", value: "3.1 sec" },
      { label: "Top Speed", value: "325 km/h" },
    ],
    description:
      "Raw, visceral, and utterly captivating. The Huracán EVO Spyder delivers an open-air supercar experience that transforms every road in Ibiza into an event.",
  },
  {
    slug: "lamborghini-urus-s",
    name: "Lamborghini Urus S",
    image: carLamborghiniUrus,
    gallery: ibizaCarGalleries["lamborghini-urus-s"],
    price: "From €1.000/day",
    specs: [
      { label: "Passengers", value: "5" },
      { label: "Engine", value: "4.0L V8 Biturbo" },
      { label: "Power", value: "660 HP" },
      { label: "0–100 km/h", value: "3.5 sec" },
      { label: "Top Speed", value: "305 km/h" },
    ],
    description:
      "The world's first Super SUV — combining Lamborghini's unmistakable design DNA with everyday versatility and commanding presence on the road.",
  },
  {
    slug: "porsche-911-gt3-rs",
    name: "Porsche 911 GT3 RS",
    image: null,
    gallery: ibizaCarGalleries["porsche-911-gt3-rs"],
    price: "From €1.000/day",
    specs: [
      { label: "Passengers", value: "2" },
      { label: "Engine", value: "4.0L Flat-6" },
      { label: "Power", value: "525 HP" },
      { label: "0–100 km/h", value: "3.2 sec" },
      { label: "Top Speed", value: "296 km/h" },
    ],
    description:
      "The ultimate track-bred Porsche for the road. The GT3 RS delivers uncompromising performance with its naturally aspirated flat-six and race-derived aerodynamics.",
  },
  {
    slug: "bentley-bentayga",
    name: "Bentley Bentayga",
    image: carBentley,
    price: "From €1.000/day",
    specs: [
      { label: "Passengers", value: "5" },
      { label: "Engine", value: "6.0L W12" },
      { label: "Power", value: "608 HP" },
      { label: "0–100 km/h", value: "4.1 sec" },
      { label: "Top Speed", value: "301 km/h" },
    ],
    description:
      "The world's most luxurious SUV, offering unmatched comfort and effortless power. Ideal for those who appreciate prestige in every detail.",
  },
  {
    slug: "mercedes-sl63-amg",
    name: "Mercedes SL63 AMG",
    image: null,
    price: "From €550/day",
    specs: [
      { label: "Passengers", value: "2" },
      { label: "Engine", value: "4.0L V8 Biturbo" },
      { label: "Power", value: "585 HP" },
      { label: "0–100 km/h", value: "3.6 sec" },
      { label: "Top Speed", value: "317 km/h" },
    ],
    description:
      "Grand touring redefined — the SL63 AMG combines open-air elegance with commanding performance for the ultimate coastal cruise.",
  },
  {
    slug: "porsche-911-carrera-4s",
    name: "Porsche 911 Carrera 4S Cabrio",
    image: carPorsche,
    gallery: ibizaCarGalleries["porsche-911-carrera-4s"],
    price: "From €500/day",
    specs: [
      { label: "Passengers", value: "4" },
      { label: "Engine", value: "3.0L Flat-6" },
      { label: "Power", value: "470 HP" },
      { label: "0–100 km/h", value: "3.5 sec" },
      { label: "Top Speed", value: "322 km/h" },
    ],
    description:
      "Timeless design meets exhilarating performance. The 911 Carrera 4S delivers a driving experience that perfectly complements the spirit of the island.",
  },
  {
    slug: "mercedes-g63-amg",
    name: "Mercedes G63 AMG",
    image: carMercedesG63,
    gallery: ibizaCarGalleries["mercedes-g63-amg"],
    price: "From €450/day",
    specs: [
      { label: "Passengers", value: "5" },
      { label: "Engine", value: "4.0L V8 Biturbo" },
      { label: "Power", value: "585 HP" },
      { label: "0–100 km/h", value: "4.5 sec" },
      { label: "Top Speed", value: "220 km/h" },
    ],
    description:
      "An icon of automotive design. The G63 AMG combines unmistakable presence with refined luxury and effortless power across any terrain.",
  },
  {
    slug: "audi-rsq8",
    name: "Audi RSQ8",
    image: carAudiRsq8,
    gallery: ibizaCarGalleries["audi-rsq8"],
    price: "From €450/day",
    specs: [
      { label: "Passengers", value: "5" },
      { label: "Engine", value: "4.0L V8 TFSI" },
      { label: "Power", value: "600 HP" },
      { label: "0–100 km/h", value: "3.8 sec" },
      { label: "Top Speed", value: "305 km/h" },
    ],
    description:
      "The fastest SUV in its class — blending Audi's cutting-edge technology with breathtaking performance and understated luxury.",
  },
  {
    slug: "range-rover-sport-dynamic",
    name: "Range Rover Sport Dynamic",
    image: carRangeRoverSport,
    gallery: ibizaCarGalleries["range-rover-sport-dynamic"],
    price: "From €350/day",
    specs: [
      { label: "Passengers", value: "5" },
      { label: "Engine", value: "3.0L I6" },
      { label: "Power", value: "400 HP" },
      { label: "0–100 km/h", value: "5.8 sec" },
      { label: "Top Speed", value: "242 km/h" },
    ],
    description:
      "The new Range Rover Sport Dynamic combines contemporary design with refined capability — effortlessly suited to Ibiza's diverse landscapes.",
  },
  {
    slug: "land-rover-defender-110",
    name: "Land Rover Defender 110",
    image: carDefender,
    gallery: ibizaCarGalleries["land-rover-defender-110"],
    price: "From €360/day",
    specs: [
      { label: "Passengers", value: "7" },
      { label: "Engine", value: "3.0L I6" },
      { label: "Power", value: "400 HP" },
      { label: "0–100 km/h", value: "6.1 sec" },
      { label: "Top Speed", value: "191 km/h" },
    ],
    description:
      "The iconic Defender 110 combines rugged capability with refined luxury — perfect for exploring Ibiza's hidden corners, from secluded beaches to hilltop restaurants.",
  },
  {
    slug: "range-rover-sport",
    name: "Range Rover Sport",
    image: carRangeRover,
    gallery: ibizaCarGalleries["range-rover-sport"],
    price: "From €250/day",
    specs: [
      { label: "Passengers", value: "5" },
      { label: "Engine", value: "3.0L SDV6" },
      { label: "Power", value: "300 HP" },
      { label: "0–100 km/h", value: "7.2 sec" },
      { label: "Top Speed", value: "222 km/h" },
    ],
    description:
      "Commanding presence meets refined comfort. The Range Rover Sport is the ideal companion for navigating Ibiza in style and ease.",
  },
];
